module.exports = __webpack_public_path__ + "assets/img/video-placeholder.f6a035c0.png";